import React, { useCallback } from 'react';
import { useModalStore, useAuthStore } from '@/store';
import ChatInputBanner, { ChatInputBannerAction } from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

function ChatInputCreditsBanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();
  const company = useAuthStore(state => state.user?.credits?.business);

  const handleGetCredits = useCallback(() => {
    openModal('CreditsPurchaseModal', { initialTab: 'buy-credits' });
  }, [openModal]);

  return (
    <ChatInputBanner color="danger" level={level} isCloseable={isCloseable} isDetached={isDetached}
      actions={<ChatInputBannerAction onPress={handleGetCredits}>{company ? 'Business credit options' : t('chatInput.credits.getMoreCredits')}</ChatInputBannerAction>}>
      {company ? 'Your company allowance does not cover this message.' : t('chatInput.credits.insufficientCredits')}
    </ChatInputBanner>
  );
}

export default React.memo(ChatInputCreditsBanner);